import { Vestiging } from "@/entities/vestiging";
import { VestigingenUpdateHandler } from "../../shared";
import { FaciliteitenDetailsForStation } from "./faciliteiten-details-for-station";

interface LokaleVestigingenSectionProps {
    lokaleVestigingenByStation: Record<string, Vestiging[]>;
    onVestigingUpdate: VestigingenUpdateHandler;
}

export function LokaleVestigingenSection({ lokaleVestigingenByStation, onVestigingUpdate }: Readonly<LokaleVestigingenSectionProps>) {
    return (
        <div className="space-y-4">
            <h4 className="text-xl font-medium">Lokale vestigingen</h4>
            {Object.entries(lokaleVestigingenByStation).map(([stationCode, vestigingen]) => {
                return (
                    <FaciliteitenDetailsForStation
                        key={stationCode}
                        variant="lokaleVestiging"
                        vestigingen={vestigingen}
                        onVestigingUpdate={onVestigingUpdate}
                        stationCode={stationCode}
                    />
                );
            })}
        </div>
    );
}
